module.exports = __webpack_public_path__ + "img/icon-menu.959d2406.svg";